import React from "react";

type CardProps = {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  description?: React.ReactNode;
  icon?: string; // material-icons name or image path
  image?: string;
  children?: React.ReactNode;
  className?: string;
  onClick?: () => void;
};

const Card: React.FC<CardProps> = ({
  title,
  subtitle,
  description,
  icon,
  image,
  children,
  className = "",
  onClick,
}) => {
  return (
    <div
      className={`bg-white rounded-2xl p-12 py-14 shadow-[0_4px_20px_rgba(15,16,40,0.08)] transition-all  hover:shadow-[0_12px_40px_rgba(15,16,40,0.12)] ${className}`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
    >
      <div className="flex items-start gap-4">
        {icon && (
          <div className="flex items-center justify-center bg-gray-100 rounded-full w-14 h-14 shrink-0">
            {icon.startsWith("/") ? (
              <img src={icon} alt="" className="object-contain w-8 h-8" />
            ) : (
              <span className="material-icons-round text-[22px] text-navy">{icon}</span>
            )}
          </div>
        )}

        <div className="flex-1">
          {subtitle && <div className="text-[1.2rem] text-gray-500 mb-1">{subtitle}</div>}
          {title && <h3 className="text-[1.6rem] font-semibold text-black mb-2">{title}</h3>}
          {description && <p className="text-[1.4rem] text-gray-5 leading-[1.6]">{description}</p>}
        </div>

        {image && (
          <div className="hidden ml-4 md:block">
            <img
              src={image}
              alt={typeof title === "string" ? title : ""}
              className="object-contain w-32 h-20 rounded-lg"
            />
          </div>
        )}
      </div>

      {children && <>{children}</>}
    </div>
  );
};

export default Card;
